import React, { useState } from 'react';
import ImageUpload from "../components/ImageUpload";
import { connect } from 'react-redux';

const PopupModal = ({ isOpen, onClose, onEdit, children, vehicleName, onContinueClick, showDescription }) => {

  const LOCAL_DECRIPTION_KEY = "Decription_Key";  
  const [description, setDescription] =  useState(
      ''
    );

  const handleChange = (value) => {
    setDescription(value);
     localStorage.setItem(LOCAL_DECRIPTION_KEY, value);
  }

  if (!isOpen) return null; // Don't render if modal is closed
  const isDescriptionFilled = description.trim().length > 0;

  return (
    <div style={styles.overlay}>
       <div style={{
         background : "white",
         width : "335px",
         height: showDescription ? "620px" : "400px",
         borderRadius : "8px",
         padding : "20px",
         position : "relative",
         display : "flex",
         flexDirection : "column",
       } }>
        {/* Close Button */}
        <button style={styles.closeButton} onClick={onClose} aria-label="Close">
          ×
        </button>

        {/* Modal Content */}
        {children}

        {/* Labels & Input Section */}
        <div style={styles.modalContent}>
          {/* Vehicle Label */}
          <label className="text-vehicel-title">Vehicle</label>
          {/* Vehicle Name with Edit Icon */}
          <div style={styles.vehicleContainer}>
          <label className="text-vehicel-name">{vehicleName.display_name}</label>
            <img src="/static/img/IconButton.png" alt="Edit" onClick={onEdit} style={styles.editIcon} />
          </div>
          {/* Issue Description */}
          {showDescription && <label style={styles.issueLabel}>Describe your issue.</label>}
          {showDescription && <textarea
            placeholder="I hear a rattling sound near my engine."
            style={styles.inputBox}
            className='text-description'
            value={description}
             onChange={(e) => handleChange(e.target.value)}
          />}
          {/* Image Upload Section */}
          <div style={styles.uploadContainer}>
            <ImageUpload vehicle={vehicleName} />
          </div>
        </div>

        {/* Modal Actions */}
        <div style={styles.modalFooter}>
          {showDescription && <button
            style={{
              ...styles.continueButton,
              backgroundColor: isDescriptionFilled ? "#212B36" : "#919EAB3D",

              color: isDescriptionFilled ? "white" : "#919EABCC",
              cursor: isDescriptionFilled ? "pointer" : "not-allowed",
            }}
            className="btn btn-large header"
            disabled={!isDescriptionFilled}
            onClick={() => isDescriptionFilled && onContinueClick(description)}
          >
            Continue
          </button>}
          {!showDescription && <button
            style={{
              ...styles.continueButton,
              backgroundColor: "#212B36",

              color: "white",
              cursor: "pointer",
            }}
            className="btn btn-large header"
            disabled={false}
            onClick={() => onContinueClick(description)}
          >
            Continue
          </button>}
        </div>
      </div>
    </div>
  );
};

const styles = {
  /* Overlay for modal background */
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.6)", // Dark transparent background
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },

  /* Modal container */
  modalContainer: {
    background: "white",
    width: "335px",
    height: "600px",
    borderRadius: "8px",
    padding: "20px",
    position: "relative",
    display: "flex",
    flexDirection: "column",
  },
  modalContent: {
    marginTop: "25px",
  },
  /* Close Button (X) */
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    background: "transparent",
    border: "none",
    fontSize: "25px",
    color: "#333",
    cursor: "pointer",
  },

  /* Labels */
  label: {
    fontSize: "14px",
    fontWeight: "450",
    color: "#637381",
    marginBottom: "5px",
  },

  vehicleContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
  },

  vehicleNameStyle: {
    fontSize: "14px",
    fontWeight: "450",
    color: "#212B36",
    marginRight: "8px",
    lineHeight: "22px",
  },

  editIcon: {
    width: "30px",
    height: "24px",
    cursor: "pointer",
    marginLeft: "5px",
  },

  /* Issue Label */
  issueLabel: {
    fontSize: "24px",
    fontWeight: "700",
    color: "#161C24",
    marginBottom: "30px",
    lineHeight: "36px",
  },

  /* Input Box */
  inputBox: {
    marginTop: "20px",
    marginLeft: "3px",
    borderRadius: "5px",
    width: "98%",
    height: "98px",
    border: "1px dashed lightgray",
    resize: "none",
  },

  /* Upload Section */
  uploadContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // padding: "20px",
    borderRadius: "5px",
    //marginTop: "15px",
  },

  /* Modal Footer */
  modalFooter: {
    display: "flex",
    justifyContent: "right",
    marginTop: "0px",
  },

  /* Continue Button */
  continueButton: {
    backgroundColor: "#919EAB3D",
    color: "#919EABCC",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};



function mapStateToProps(state) {
  return {
    account: state.ui.account,
    schedule: state.ui.schedule,
    cart: state.ui.cart,
    diagnostic: state.ui.diagnostic,
    changeBooking: state.ui.changeBooking,
    homeAddress: state.ui.homeAddress,
    customerLocation: state.ui.customerLocation,
    clientLocations: state.ui.clientLocations,
    compatibleDates: state.ui.compatibleDates,
    z3pConfiguration: state.ui.z3pConfiguration,
    keyLocation: state.ui.keyLocation,
    goBack: state.ui.goBack,
    vehicle: state.ui.pricing,
    vehicles: state.ui.vehicles,
    bookingImages: state.ui.bookingImages,
    scheduledWorks: state.ui.scheduledWorks,
  };
}
export default connect(mapStateToProps, null)(PopupModal);
